import {Component, OnInit, ViewChild} from '@angular/core';
import {NodeBuilder} from "../../../../../../../shared/models";
import { UntypedFormArray, ReactiveFormsModule } from "@angular/forms";
import {MultiProductForm, MultiProductNode} from "./multi-product";
import {
  ClickatellButtonToggleComponent,
  ToggleData
} from "../../../../../../../shared/components/clickatell-button-toggle/clickatell-button-toggle.component";
import { newStepValue } from "../../../../../services/flowBuilder/utils/constants";
import { ClickatellExpansionPanelComponent } from '../../../../../../../shared/components/clickatell-expansion-panel/clickatell-expansion-panel.component';
import { MatExpansionPanelTitle } from '@angular/material/expansion';
import { ClickatellFormValidationComponent } from '../../../../../../../shared/components/clickatell-form-validation/clickatell-form-validation.component';
import { ActiveFormDirective } from '../../../../../../../shared/directives/active-form/active-form.directive';
import { CMSComponent } from '../../../../../../../shared/components/cms/cms.component';
import { TooltipDirective } from '../../../../../../../shared/directives/tooltips/tooltip.directive';
import { NgClass } from '@angular/common';
import { NextSelectorComponent } from '../../../../json-to-from/next-selector/next-selector.component';

const NODE_TYPE = "multiProduct";

@Component({
    selector: 'multi-product',
    templateUrl: './multi-product.component.html',
    styleUrls: ['./multi-product.component.scss'],
    imports: [ClickatellExpansionPanelComponent, MatExpansionPanelTitle, ReactiveFormsModule, ClickatellFormValidationComponent, ActiveFormDirective, CMSComponent, ClickatellButtonToggleComponent, TooltipDirective, NgClass, NextSelectorComponent]
})
export class MultiProductComponent extends NodeBuilder implements OnInit {

  @ViewChild('isDynamic')
  isDynamic: ClickatellButtonToggleComponent;

  multiProductForms: MultiProductForm = undefined;
  stepUniqueID: string = '';
  readonly PLACEHOLDERS = {
    menuHeader: "Name the menu header",
    bodyText: "Enter a body text",
    subHeader: "Enter a sub header",
    buttonText: "Enter a button Text",
    catalogId: "Enter the catalogue ID",
    productId: "Enter the product ID"
  }

  readonly TOGGLE_DATA: ToggleData = {
    titles: {
      "left": "Dynamic",
      "right": "Predefined"
    }
  }

  readonly MAX_PRODUCTS = 30;
  readonly MIN_PRODUCTS = 1;

  isMin: boolean;
  isMax: boolean;

  constructor() {
    super(NODE_TYPE);
  }

  ngOnInit(): void {
  }

  set buildForm(stepData: any) {
    this.stepUniqueID = stepData.metadata?.stepUniqueID ? stepData.metadata?.stepUniqueID : '';
    this.multiProductForms = MultiProductNode.toForm(stepData, this.canEdit);
    this.setMinMax();

    // Patch variable success value for new step
    if (this.multiProductForms.menuParams.get('next').value === newStepValue) {
      this.multiProductForms.menuParams.get('next').setValue('step' + this.getNextStep());
    }
  }

  get getStepData(): {} {
    const nodeData = new MultiProductNode().getNodeData(this.multiProductForms);
    if(this.stepUniqueID !== '') {
      nodeData['metadata'].stepUniqueID = this.stepUniqueID;
    }
    return nodeData;
  }

  get isNodeValid(): boolean {
    this.multiProductForms.menuParams.markAllAsTouched();
    this.multiProductForms.productIds.markAllAsTouched();

    if (this.isDynamic.state) {
      return this.multiProductForms.menuParams.valid && this.multiProductForms.productIds.get("0").valid;
    }

    return this.multiProductForms.menuParams.valid && this.multiProductForms.productIds.valid;
  }

  private setMinMax() {
    const productIds: UntypedFormArray = this.multiProductForms.productIds as UntypedFormArray;
    let isMin, isMax = false;

    if (productIds.length >= this.MAX_PRODUCTS) {
      isMax = true;
      isMin = false;
    } else if (productIds.length === this.MIN_PRODUCTS) {
      isMax = false;
      isMin = true;
    }
    this.isMin = isMin;
    this.isMax = isMax;
  }

  public addProduct() {
    const productIds: UntypedFormArray = this.multiProductForms.productIds as UntypedFormArray;
    if(productIds.length >= this.MAX_PRODUCTS)  {
      return
    }
    productIds.push(MultiProductNode.productIdTemplate("", this.canEdit))
    this.setMinMax()
  }

  public removeProduct(index: number) {
    const productIds: UntypedFormArray = this.multiProductForms.productIds as UntypedFormArray;
    if(productIds.length === this.MIN_PRODUCTS)  {
      return
    }
    productIds.removeAt(index);
    this.setMinMax()
  }

}
